module.exports = __webpack_public_path__ + "img/reference-inawolf.b0e0aaf1.webp";